import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import WelcomeBanner from '../components/common/WelcomeBanner';
import BlogWriterContent from './BlogWriter';
import PostManagementTable from './SocialMedia';
import { GifMaker } from './GifMaker';
import TrendingTools from '../components/common/TrendingTools';
import TextToImage from './TextToImage';
import TextToLogo from './TextToLogo';
import ImageEditTools from './ImageEditTools';

const Home = () => {
  const [currentTool, setCurrentTool] =
    useState<keyof typeof banner>('blogWriter');
  const location = useLocation();

  useEffect(() => {
    // Extract the tool name from the pathname
    const path = location.pathname.split('/').pop() || 'blogwriter';
    if (path in banner) {
      setCurrentTool(path as keyof typeof banner);
    } else {
      setCurrentTool('blogWriter');
    }
  }, [location]);

  const banner = {
    blogWriter: '/blogbanner.png',
    socialMedia: '/socialmediabanner.png',
    textToImage: '/texttoimagebanner.png',
    textToLogo: '/texttologobanner.png',
    imageEditor: '/imageeditbanner.png',
    gifMaker: '/gifmakerbanner.png',
  };

  // Component mapping object
  const contentComponents = {
    blogWriter: <BlogWriterContent />,
    socialMedia: <PostManagementTable />,
    textToImage: <TextToImage />,
    gifMaker: <GifMaker />,
    textToLogo: <TextToLogo />, // Replace with the actual component
    imageEditor: <ImageEditTools />, // Replace with the actual component
  };
  const featuresData: {
    [key in keyof typeof banner]: { title: string; description: string };
  } = {
    blogWriter: {
      title: 'Blog Writer',
      description:
        'Discover a free Al blog writer tool that creates engaging and well-written articles effortlessly. With Kreaitor boost your content creation process and quality today!',
    },
    socialMedia: {
      title: 'Social media generator',
      description:
        'Whether you are promoting your brand, engaging with followers, or sharing updates – we can generate ideas on different topics.',
    },
    textToImage: {
      title: 'Text to image',
      description:
        'Our tool instantly creates stunning images that bring your imagination to life—perfect for socials, blogs, and more.',
    },
    textToLogo: {
      title: 'Text to logo',
      description:
        'Design logos with ease and efficiency. Quickly create professional logos tailored to your brand identity or project needs with just a few clicks.',
    },
    gifMaker: {
      title: 'GIF maker',
      description:
        'Design logos with ease and efficiency. Quickly create professional logos tailored to your brand identity or project needs with just a few clicks.',
    },
    imageEditor: {
      title: 'Image editor tools',
      description:
        'Effortlessly replace objects, remove distractions, and upscale images with precision using our advanced editing tools designed for perfection.',
    },
  };
  return (
    <div className="flex flex-col gap-10 min-h-screen  items-center  rounded-lg  bg-background-main overflow-auto">
      <WelcomeBanner
        data={featuresData[currentTool]}
        image={banner[currentTool]}
      />

      {/* Render the component based on current tool */}
      {contentComponents[currentTool] || <BlogWriterContent />}

      <TrendingTools />
    </div>
  );
};

export default Home;
